import angular from 'angular'
import moment from 'moment-timezone'
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
angular.module('pub.post.edit', []).controller('PostsEditCtrl', PostsEditCtrl)

/** @ngInject */
function PostsEditCtrl(
  $scope,
  $state,
  $sce,
  $rootScope,
  $stateParams,
  $timeout,
  PostsService,
  CacheService,
  UploadService,
  CsvService,
) {
  var vm = this
  vm.model = {
    'img-h': '',
  }
  vm.pathImgH = ''
  vm.parentId = $stateParams.parentId
  vm.params = $stateParams.id
  vm.isOpen = false
  vm.isOpen2 = false
  vm.isEvent = $stateParams.event
  vm.isCreate = $stateParams.create

  const toolbarOptions = {
    container: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],

      [{ list: 'ordered' }, { list: 'bullet' }],

      // [{ script: 'sub' }, { script: 'super' }], // superscript/subscript

      // [{ indent: '-1' }, { indent: '+1' }], // outdent/indent

      // [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['clean'], // remove formatting button

      ['link'], // link and image, video
    ],
    handlers: {
      // image: function () {
      //   vm.range = this.quill.getSelection()
      //   $('#modalImagePost').modal('show')
      // },
      // video: function () {
      //   vm.range = this.quill.getSelection()
      //   $('#modalVideoPost').modal('show')
      // },
    },
  }

  const options = {
    modules: {
      toolbar: toolbarOptions,
    },
    placeholder: 'Write something...',
    theme: 'snow',
  }
  const editor = new Quill('.editor', options)

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  vm.convertTimezone = function () {
    if (vm.data1) {
      vm.timezoneDatePublishedNY = moment(vm.data1)
        .tz('America/New_York')
        .format('MM/DD/YYYY HH:mm A')
      vm.timezoneDatePublishedLA = moment(vm.data1)
        .tz('America/Los_Angeles')
        .format('MM/DD/YYYY HH:mm A')
    }
    if (vm.data2) {
      vm.timezoneDateExpiredNY = moment(vm.data2)
        .tz('America/New_York')
        .format('MM/DD/YYYY HH:mm A')
      vm.timezoneDateExpiredLA = moment(vm.data2)
        .tz('America/Los_Angeles')
        .format('MM/DD/YYYY HH:mm A')
    }
  }

  PostsService.listSegmentation().then(function (result) {
    vm.segmentations = _.filter(result.results, { arch: false })
  })

  if (vm.params !== '0') {
    vm.id = $stateParams.id
    PostsService.listPostSegmentation($stateParams.parentId, $stateParams.id).then(
      function (result) {
        vm.postSegmentations = generateType(result.results)
      },
    )
    PostsService.getId($stateParams.parentId, $stateParams.id).then(function (result) {
      vm.model = result.results
      if (vm.isCreate === 'false' || vm.isConfirm === undefined) {
        if (vm.model['ts-p'] !== undefined && vm.model['ts-p'] !== 0) {
          vm.model['ts-p'] = vm.model['ts-p']
            .toString()
            .substring(0, vm.model['ts-p'].toString().length - 3)
          vm.model['ts-p'] = new Date(parseInt(vm.model['ts-p']))
          vm.data1 = angular.copy(vm.model['ts-p'])
          vm.timezoneDatePublishedNY = moment(vm.model['ts-p'])
            .tz('America/New_York')
            .format('MM/DD/YYYY HH:mm A')
          vm.timezoneDatePublishedLA = moment(vm.model['ts-p'])
            .tz('America/Los_Angeles')
            .format('MM/DD/YYYY HH:mm A')
        }
      } else {
        vm.model['ts-p'] = null
      }

      if (vm.model['ts-x-pin'] !== undefined && vm.model['ts-x-pin'] !== 0) {
        vm.model['ts-x-pin'] = vm.model['ts-x-pin']
          .toString()
          .substring(0, vm.model['ts-x-pin'].toString().length - 3)
        vm.model['ts-x-pin'] = new Date(parseInt(vm.model['ts-x-pin']))
        vm.data2 = angular.copy(vm.model['ts-x-pin'])
        vm.timezoneDateExpiredNY = moment(vm.model['ts-x-pin'])
          .tz('America/New_York')
          .format('MM/DD/YYYY HH:mm A')
        vm.timezoneDateExpiredLA = moment(vm.model['ts-x-pin'])
          .tz('America/Los_Angeles')
          .format('MM/DD/YYYY HH:mm A')
      }

      if (vm.model['img-h'].indexOf('mp4') !== -1 || vm.model['img-h'].indexOf('mov') !== -1) {
        vm.model.isVideo = true
        vm.model.video = $sce.trustAsResourceUrl($rootScope.urlS3 + '/posts/' + vm.model['img-h'])
      } else {
        vm.model.isVideo = false
      }

      const content = JSON.parse(vm.model['txt-json'])
      editor.setContents(content)

      if (vm.isEvent) {
        var bundleId = localStorage.getItem('bundleId')
        if (vm.model.url === undefined || vm.model.url === '') {
          vm.model.url = 'bundles/' + bundleId
        }
      }
    })
  } else {
    vm.newId = parseInt(vm.params.split('?')[1])
  }

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.save = function () {
    var model = angular.copy(vm.model)
    delete model.ts
    model['id-u'] = null
    delete model.u
    var msg = ''

    model.txt = editor.root.innerHTML
    model['txt-json'] = JSON.stringify(editor.getContents())

    if (model.t === undefined || model.txt === undefined) {
      swal('Required title and description fields.', '', 'error')
      return
    }

    if (model['txt-json']) {
      model['k-txt'] = 1
    }

    if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        model['ts-p'] = date

        if (new Date(vm.data1) < new Date()) {
          msg = 'Post Saved and Published'
        } else {
          msg = 'Post Saved to Drafts as Pending'
        }
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else if (model['ts-p'] === undefined || model['ts-p'] === null) {
      model['ts-p'] = null
      msg = 'Post Saved to Drafts'
    }

    if (vm.data2 !== undefined && vm.data2 !== '' && vm.data2 !== null) {
      if (isDate(vm.data2)) {
        var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
        model['ts-x-pin'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-x-pin'] = null
    }

    if (model.pin === false) {
      model.pin = null
    }

    if (model.id !== undefined && model.id !== '' && model.id !== 0) {
      PostsService.update($stateParams.parentId, model.id, model).then(function () {
        var msg = 'Post Saved'
        $('#alertResult').show()
        $('#resultMsg').text(msg)
        if (vm.isCreate === 'true' && vm.isEvent === 'true') {
          var pushId = parseInt(localStorage.getItem('pushId'))
          $state.go('admin.notification_history.edit', {
            id: pushId,
            event: true,
            create: true,
          })
          return
        }

        if (vm.isEvent) {
          $state.go('admin.event')
          return
        }
        $timeout(function () {
          $state.go('pub.channels.posts', { parentId: vm.parentId })
        }, 50)
      })
    } else {
      PostsService.save($stateParams.parentId, model).then(function () {
        $timeout(function () {
          $state.go('pub.channels.posts', { parentId: vm.parentId })
        }, 50)
      })
    }
  }

  vm.cancel = function () {
    swal(
      {
        title: 'Cancel Post',
        text: 'You really want to cancel ?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          if (vm.isEvent) {
            $state.go('admin.event')
            return
          }
          $state.go('pub.channels.posts', { parentId: vm.parentId })
        } else {
          return
        }
      },
    )
  }

  vm.uploadH = function (item) {
    vm.loadH = true
    var id = 0
    if (item.id === undefined) {
      id = vm.newId
    } else {
      id = item.id
    }
    UploadService.save('posts', vm.pathImgH, 'img-h', id).then(function (fileName) {
      vm.loadH = false
      item['img-h'] = fileName
      if (item['img-h'].indexOf('mp4') !== -1 || item['img-h'].indexOf('mov') !== -1) {
        vm.model.isVideo = true
        vm.model.video = $sce.trustAsResourceUrl($rootScope.urlS3 + '/posts/' + vm.model['img-h'])
      } else {
        vm.model.isVideo = false
      }
    })
  }

  vm.addSegmentation = function () {
    PostsService.addPostSegmentation(
      $stateParams.parentId,
      $stateParams.id,
      vm.segmentationId,
    ).then(
      function () {
        PostsService.listPostSegmentation($stateParams.parentId, $stateParams.id).then(
          function (result) {
            vm.postSegmentations = generateType(result.results)
          },
        )
      },
      function () {
        swal('This user segmentation already exists', '', 'error')
      },
    )
  }

  vm.deleteSegmentation = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: 'You really want to delete?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          PostsService.removePostSegmentation($stateParams.parentId, $stateParams.id, id).then(
            function () {
              PostsService.listPostSegmentation($stateParams.parentId, $stateParams.id).then(
                function (result) {
                  vm.postSegmentations = generateType(result.results)
                },
              )
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.exportCsv = function () {
    CsvService.validSafari()
    var listCsv = []

    PostsService.listPostSegmentationUsers($stateParams.parentId, $stateParams.id).then(
      function (result) {
        var users = result.results

        for (var i = 0; i < users.length; i++) {
          listCsv.push({
            id: users[i].id,
            username: users[i].username === undefined ? '' : users[i].username,
            email: users[i].email,
            name: users[i].name === undefined ? '' : users[i].name,
          })
        }

        var csv = CsvService.convertArrayOfObjectsToCSV({
          data: listCsv,
        })

        if (csv === null) {
          return
        }

        var pom = document.createElement('a')
        var csvContent = csv //here we load our csv data
        var blob = new Blob([csvContent], {
          type: 'text/csv;charset=utf-8;',
        })
        var url = URL.createObjectURL(blob)
        pom.href = url
        pom.setAttribute('download', vm.model.t + '.csv')
        pom.click()
      },
    )
  }

  function generateType(model) {
    for (var i = 0; i < model.length; i++) {
      if (model[i].k === 1) {
        model[i].type = 'Product'
      } else if (model[i].k === 2) {
        model[i].type = 'Bundle'
      } else if (model[i].k === 3) {
        model[i].type = 'Set'
      }
    }
    return model
  }
}
